export type Pipet = {
    Id: number,
    LabId: number,
    SerialNumber: string,
    Manufacturer: string,
    Volume?: number,
    InactiveDate: Date,
}

export function apiModelToPipet(apiModel: any) {
    return {
        Id: apiModel.id,
        LabId: apiModel.labId,
        SerialNumber: apiModel.serialNumber,
        Manufacturer: apiModel.manufacturer,
        Volume: apiModel.volume,
        InactiveDate: apiModel.inactiveDate ? new Date(Date.parse(apiModel.inactiveDate)) : null as any,
    } as Pipet;
}

export const blankPipet = {
    Id: 0,
    LabId: 0,
    SerialNumber: "",
    Manufacturer: "",
    Volume: 10,
    InactiveDate: null as any,
} as Pipet;
